import RouterUtils from '../../../../routing/RouterUtils';
import { ApiEndpoints } from '../../../../webservices/endpoint';

export class QrWorkerTokenRequest {
    _id; // number
    _contractorId; // number

    constructor() {
        this._id = -1;
        this._contractorId = 1;
    }

    setId(id) {
        this._id = id;
    }

    setContractorId(id) {
        this._contractorId = id;
    }

    route() {
        return RouterUtils.generateRoute(ApiEndpoints.WORKER_QR_TOKEN, {
            contractorId: this._contractorId,
            id: this._id,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/predefined-fields/resource-contractor-schema/worker-qr/QrWorkerTokenRequest.js